import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/course/search-icon.png'


const _hoisted_1 = { class: "bar" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "nav-sel" }
const _hoisted_5 = { class: "pop-content" }
const _hoisted_6 = ["onClick"]

import { ref, watch } from 'vue'
import { useThemeColor } from '@/utils/theme'


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
  activeIndex: {
    type: Number,
    default: 0
  }
},
  emits: ['onInputClick', 'onSort'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "6e07aa9c": (_unref(themeColor))
}))

const props = __props

const emits = __emit
const themeColor = useThemeColor()
const value = ref('')
const show = ref(false)
const names = ['app_publish_time', 'app_update_time', 'app_learning_count']
const list = [{ sortType: 1 }, { sortType: 2 }, { sortType: 3 }]
const selectIndex = ref(props.activeIndex || 0)
const checkSort = () => {
  show.value = !show.value
}
const onInputClick = () => {
  emits('onInputClick')
}
const onSort = (index: number) => {
  selectIndex.value = index
  show.value = !show.value
  emits('onSort', list[selectIndex.value])
}

watch(
  () => props.activeIndex,
  (newValue) => {
    selectIndex.value = newValue
  }
)

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "nav-left",
          onClick: onInputClick
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            class: "nav-search-icon",
            src: _imports_0
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            class: "nav-search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
            placeholder: _ctx.$t('app_searchPrompt')
          }, null, 8, _hoisted_3), [
            [_vModelText, value.value]
          ])
        ]),
        _createElementVNode("div", {
          class: "nav-right",
          onClick: checkSort
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(names[selectIndex.value])), 1),
          _createVNode(_component_van_icon, {
            class: "nav-exp",
            name: show.value ? 'arrow-up' : 'arrow-down',
            color: "#030303",
            size: "14px"
          }, null, 8, ["name"])
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      style: _normalizeStyle([{"top":"44px"}, { height: '150px' }]),
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["pop-item", { active: selectIndex.value === index }]),
              key: item.sortType,
              onClick: ($event: any) => (onSort(index))
            }, _toDisplayString(_ctx.$t(names[index])), 11, _hoisted_6)
          }), 64))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})